import { render, staticRenderFns } from "./SubmitForm7.vue?vue&type=template&id=f55c4f64&scoped=true"
import script from "./SubmitForm7.vue?vue&type=script&lang=ts"
export * from "./SubmitForm7.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55c4f64",
  null
  
)

export default component.exports